exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal__video .v--modal-box {\n  padding: 20px;\n}\n@media (max-width: 990px) {\n.modal__video .v--modal-box {\n    width: 100% !important;\n    left: 0 !important;\n}\n}\n@media (max-width: 768px) {\n.modal__video .v--modal-box {\n    height: 350px !important;\n}\n}\n@media (max-width: 575px) {\n.modal__video .v--modal-box {\n    height: 250px !important;\n}\n}\n.modal__video .v--modal-box .btn__close {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  line-height: 0;\n}\n.modal__video .v--modal-box iframe {\n  width: 100%;\n  height: 100%;\n}", ""]);

// exports
